module.exports = __webpack_public_path__ + "static/media/close-color.2f65f920.svg";